import { createSlice } from '@reduxjs/toolkit';

const mainEngineSlice = createSlice({
  name: 'mainEngine',
  initialState: {
    selectedEngineId: 'ME1', // Default engine ID
    engines: [] // List of available engines
  },
  reducers: {
    setSelectedEngine: (state, action) => {
      state.selectedEngineId = action.payload;
    },
    setEngines: (state, action) => {
      state.engines = action.payload;
    }
  },
});

export const { setSelectedEngine, setEngines } = mainEngineSlice.actions;
export default mainEngineSlice.reducer;